import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=bb454640"
import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb454640')) {
      api.createRecord('bb454640', component.options)
    } else {
      api.reload('bb454640', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=bb454640", function () {
      api.rerender('bb454640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/attendance-sheets/Page.vue"
export default component.exports